// initialState
const initialState = {
    minimized: true
}

// types
const CHANGE_MENU = 'CHANGE_MENU';

// reducer
const menuReducer = (state=initialState, action) => {
    switch(action.type){
        case 'CHANGE_MENU': return{
            minimized: action.payload
        }
        default: return state;
    }
}

// action
const menuAction = () => async (dispatch, getState) => {
    dispatch({
        type: CHANGE_MENU,
        payload: !getState().Menu.minimized
    })
}

// export
export { menuAction }

export default menuReducer;